import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'shared-box',
    templateUrl: './box.shared.component.html',
    styleUrls: ['./box.shared.component.scss']
})
export class BoxComponent implements OnInit {
    @Input() public feel: OLO.Components.BOX_FEEL;
    @Input() public header: TemplateRef<any>;
    @Input() public footer: TemplateRef<any>;
    @Input() public headerHorizontalPaddings: boolean = true;
    @Input() public headerVerticalPaddings: boolean = true;
    @Input() public contentHorizontalPaddings: boolean = true;
    @Input() public contentVerticalPaddings: boolean = false;
    @Input() public footerHorizontalPaddings: boolean = true;
    @Input() public footerVerticalPaddings: boolean = true;
    @Input() public headerBorder: boolean = true;
    @Input() public footerBorder: boolean = false;
    @Input() public footerShadow: boolean = true;
    @Input() public footerOverflow: boolean = false;
    @Input() public footerOnTop: boolean = false;
    @Input() public inactive: boolean = false;

    constructor() { }

    ngOnInit(): void { }
}
